<template>
    <BaseWidget :title="widget.title" :title-url="widget.titleUrl" :footer="widget.footer">
        <div>
            <apexchart
                :type="widget.content.chartData.chart.type"
                :height="widget.content.chartData.chart.height"
                :series="widget.content.chartData.series"
                :options="widget.content.chartData"
            >
            </apexchart>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '@/components/Widgets/BaseWidget.vue';

export default {
    name: 'ActivityLogGraphWidget',
    props: {
        widget: {
            required: true,
            type: Object,
        },
    },
    components: {
        BaseWidget,
    },
};
</script>
